<template>
  <div class="tabs">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabClick">
      <el-tab-pane label="Bradesco" name="Bradesco" lazy>
        <div v-if="activeName === 'Bradesco'">
          <Bradesco ref="Bradesco" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Bradesco from './bradesco/index.vue';

export default {
  name: 'Tabs',
  components: {
    Bradesco
  },
  data() {
    return {
      activeName: 'Bradesco'
    };
  },
  methods: {
    handleTabClick(tab) {
      // 标签页切换时的回调
      this.$nextTick(() => {
        // 调用当前激活组件的特定方法
        const activeComponent = this.$refs[tab.name];
        if (activeComponent && typeof activeComponent.onTabActivated === 'function') {
          activeComponent.onTabActivated();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs--border-card>.el-tabs__content {
  padding: 0;
}
</style>
